import { TableBody } from "@mui/material";
import React from "react";
import { stableSort, getComparator } from "../../core/utils";

const TableContent = ({
  data = [],
  order = "",
  orderBy = "",
  page = 0,
  rowsPerPage = 10,
  ...props
}) => {
  return (
    <TableBody>
      {stableSort(data, getComparator(order, orderBy))
        .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
        .map((item, index) => props.children(item, index))}
    </TableBody>
  );
};

export default TableContent;
